import { 
    GET_USER_CREDIT_INFO, 
    GET_USER_CREDIT_INFO_SUCCESS, 
    GET_USER_PCT_UNLOCK_HISTORY, 
    GET_USER_PCT_UNLOCK_HISTORY_SUCCESS, 
    SET_MY_CREDITS_LOADING
} from "./actionTypes";

const initialStates = {
    loading: false,
    pctUnlockHistory: [],
    noticeStr: "",
    pctUnlockHistoryTotalPages: 0,
    pctActiveSubCreditList: []
}

const myCredits = (state = initialStates, action) => {
    switch (action.type){
        case GET_USER_CREDIT_INFO:
            return {
                ...state,
                loading: true,
            }
        case GET_USER_CREDIT_INFO_SUCCESS:
            return {
                ...state,
                pctActiveSubCreditList: action.payload.pctActiveSubCreditList,
                pctUnlockHistory: action.payload.pctUnlockHistory,
                noticeStr: action.payload.noticeStr,
                pctUnlockHistoryTotalPages: action.payload.totalPages,
                loading: false,
            }
        case SET_MY_CREDITS_LOADING:
            return {
                ...state,
                loading: action.payload,
            }
        case GET_USER_PCT_UNLOCK_HISTORY:
            return {
                ...state,
                loading: true,
            }
        case GET_USER_PCT_UNLOCK_HISTORY_SUCCESS:
            return {
                ...state,
                pctUnlockHistory: action.payload.userPctUnlockList,
                noticeStr: action.payload.noticeStr,
                pctUnlockHistoryTotalPages: action.payload.totalPages,
                loading: false,
            }
        default:
            return state;
    }
}

export default myCredits;